@let lloydsRoadmapValue = lloydsRoadmap();
@let pagesValue = pages();
@for (page of pagesValue; track $index) {
  @let isLastPage = $index === pagesValue.length - 1;
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="'lbgPortfolioRoadmapReport'"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    <h2>
      {{
        ('lbgPortfolioRoadmapReport.energyConsumption.title' | translate) +
          ($index > 0 ? ' (' + ('portfolioBuildingsRoadmapReport.continued' | translate) + ')' : '')
      }}
    </h2>
    @if ($index === 0) {
      <p>{{ 'lbgPortfolioRoadmapReport.energyConsumption.description' | translate }}</p>
    }
    <cfp-lbg-report-energy-consumption-table
      [buildings]="page"
      [currencyCode]="lloydsRoadmapValue.currencyCode"
      [totals]="lloydsRoadmapValue.energyConsumptionTotals"
      [showTotals]="isLastPage"
    />
    <div class="row mt-4 g-4">
      <div class="col-auto d-flex justify-content-center align-items-center">
        <cfp-icon [icon]="'search'" [iconStyle]="'success'" [classes]="'me-2'" />
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.legend.benchmarkValue' | translate }}
      </div>
    </div>
  </cfp-report-page>
}
